import React from "react";

const AboutMe = () => {
  return (
    <section className="bg-dark text-white py-5" id="about">
      <div className="wrap">
        <div className="row justify-content-center">
          <div className="col">
            <h2 className="text-center fw-bold mb-4">About Me</h2>
            <p className="lead text-justify">
              My journey began with a deep love for mathematics, which I've been
              teaching as a self-employed tutor since 2017. In 2021, I took a
              transformative step by diving into Python and web development
              courses. That's when I discovered my passion for frontend
              development: blending 🧠 logic, 🎨 creativity, and 🖌️ design into
              one powerful field.
            </p>
            <p className="text-justify">
              I've spent nearly two years working professionally as a ReactJS
              developer, building intuitive, user-focused interfaces and gaining
              hands-on experience in modern frontend practices. After welcoming
              my wonderful daughter Emma into the world, I took a brief career
              pause to focus on motherhood, an experience that has brought even
              more determination and perspective to my work.
            </p>
            <p className="text-justify">
              Over the past year, I've dedicated myself to refining my skills,
              growing my portfolio, and preparing to re-enter the professional
              space. This website is more than a portfolio, it's a showcase of
              my passion, resilience, and commitment to delivering exceptional
              user experiences.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
